import { Box, BoxProps } from "@xcorejs/ui";
import RobeDoubleCarousel from "design-system/robe/Carousel/Double";
import ShortVideo, { ShortVideoRestructured } from "design-system/ShortVideo";
import { useLayout } from "xcore";
import VideoComponent, { VideoComponentType, VideoControls } from "../Video";

export type VideoCarouselVideos = (VideoComponentType | ShortVideoRestructured)[];

interface VideoCarouselProps extends VideoControls, BoxProps {
  videos: VideoCarouselVideos;
  keyFeaturesCarousel?: boolean;
}

const VideoCarousel = ({ videos, keyFeaturesCarousel, loop, autoplay, mute, openInModal, noControl, ...props }: VideoCarouselProps) => {
  const { stringify } = useLayout();

  return (
    <Box {...props}>
      {videos.length === 1 ? (
        // Vimeo video
        videos[0].type === "video" ? (
          <VideoComponent video={videos[0]} {...{ loop, autoplay, mute, openInModal, noControl }} />
        ) : (
          <ShortVideo video={videos[0].values} id={videos[0].id} />
        )
      ) : (
        <RobeDoubleCarousel labels={videos.map((v) => stringify(keyFeaturesCarousel ? v.title : (v.values.title ?? "")))}>
          {videos.map((v) =>
            v.type === "video" ? <VideoComponent key={v.id} video={v} moreVideos /> : <ShortVideo key={v.id} video={v.values} id={v.id} />
          )}
        </RobeDoubleCarousel>
      )}
    </Box>
  );
};

export default VideoCarousel;
